import { __awaiter } from "tslib";
import axios from 'axios';
import { tryRefresh, redirectToLogin } from '../_helpers/interceptors';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
const a = axios.create({});
const refreshAuthHandler = () => __awaiter(void 0, void 0, void 0, function* () {
    const refreshResponse = yield tryRefresh();
    if (refreshResponse) {
        return Promise.resolve();
    }
    else
        redirectToLogin();
});
createAuthRefreshInterceptor(a, refreshAuthHandler, {
    // @ts-ignore
    retryInstance: (config) => __awaiter(void 0, void 0, void 0, function* () { return new Promise((resolve) => { resolve(a.request(config)); }); })
});
export default a;
